import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { Suspense, useState } from 'react';
import { useWindowSize } from '@magento/peregrine/lib/hooks/useWindowSize';
import { useUserContext } from '@magento/peregrine/lib/context/user/';
import { Button } from 'src/components';
import { useAccountTrigger } from '@magento/peregrine/lib/talons/Header/useAccountTrigger';
import CmsBlock from '../../components/Cms/cmsBlock';
import AppBodyLayout from '../../components/Common/Layouts/appBodyLayout';
import AccessRequestModal from '../../components/Header/Account/NotLoggedInMenu/accessRequestModal';
import { getCustomerGroup } from '../../Utils/utils';
var AccountMenu = React.lazy(function () {
  return import('../../components/Header/Account/accountMenu');
});

var ResourcesTop = function ResourcesTop() {
  var _useWindowSize = useWindowSize(),
      innerWidth = _useWindowSize.innerWidth;

  var isSmallDevice = innerWidth < 640;

  var handleToggleModal = function handleToggleModal() {
    return setisRequestModalOpen(function (prevState) {
      return !prevState;
    });
  };

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isAccessRequestModalOpen = _useState2[0],
      setisRequestModalOpen = _useState2[1];

  var _useUserContext = useUserContext(),
      _useUserContext2 = _slicedToArray(_useUserContext, 1),
      isUserSignedIn = _useUserContext2[0].isSignedIn;

  var _getCustomerGroup = getCustomerGroup(),
      isTradeDirectAccount = _getCustomerGroup.isTradeDirectAccount,
      isConsumer = _getCustomerGroup.isConsumer,
      isHfEmployee = _getCustomerGroup.isHfEmployee;

  var _useAccountTrigger = useAccountTrigger(),
      accountMenuIsOpen = _useAccountTrigger.accountMenuIsOpen,
      accountMenuRef = _useAccountTrigger.accountMenuRef,
      accountMenuTriggerRef = _useAccountTrigger.accountMenuTriggerRef,
      setAccountMenuIsOpen = _useAccountTrigger.setAccountMenuIsOpen,
      handleTriggerClick = _useAccountTrigger.handleTriggerClick,
      closeAccountMenu = _useAccountTrigger.closeAccountMenu;

  return React.createElement(React.Fragment, null, isTradeDirectAccount || isConsumer || isHfEmployee || !isUserSignedIn ? React.createElement(CmsBlock, {
    identifiers: "resources-page-top"
  }) : React.createElement(CmsBlock, {
    identifiers: "resources-page-top-rfq"
  }), React.createElement(AppBodyLayout, {
    classes: {
      body: 'mb-6 sm_mb-20'
    }
  }, !isSmallDevice && !isUserSignedIn && React.createElement("div", null, React.createElement("h6", {
    className: "sm_mb-3 sm_mt-10"
  }, "Are you a professional?"), React.createElement("p", {
    className: "text-base leeading-175 sm_mb-5"
  }, "Interested in gaining access to additional information and resources?"), React.createElement(Button, {
    priority: "low",
    size: "large",
    "aria-label": "Login or create a profile",
    onClick: handleTriggerClick
  }, "LOGIN OR CREATE A WEB PROFILE"), React.createElement(Suspense, {
    fallback: null
  }, React.createElement(AccountMenu, {
    ref: accountMenuRef,
    accountMenuIsOpen: accountMenuIsOpen,
    setAccountMenuIsOpen: setAccountMenuIsOpen,
    closeAccount: closeAccountMenu,
    toggleModal: handleToggleModal
  })), isAccessRequestModalOpen && React.createElement(AccessRequestModal, {
    isOpen: isAccessRequestModalOpen,
    closeModal: handleToggleModal
  }))));
};

export default ResourcesTop;